import {zodResolver} from '@hookform/resolvers/zod';
import {useForm} from 'react-hook-form';
import {z} from 'zod';

const formSchema = z
  .object({
    mailTitleType: z.string(),
    isMailHederEnabled: z.boolean(),
    mailTitle: z.string().max(340, '340文字以内で入力してください。'),
    mailHeader: z.string().max(240, '240文字以内で入力してください。'),
    emailFieldValue: z.string().regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
      error: '正しいメールアドレスを入力してください。',
    }),
  })
  .refine(
    ({mailTitleType, mailTitle}) =>
      !(mailTitleType === 'replace' && mailTitle.trim() === ''),
    {
      path: ['mailTitle'],
      error: '入力してください。',
    },
  )
  .refine(
    ({isMailHederEnabled, mailHeader}) =>
      !(isMailHederEnabled && mailHeader.trim() === ''),
    {
      path: ['mailHeader'],
      error: '入力してください。',
    },
  );

type FormSchema = z.infer<typeof formSchema>;

export function useTestMailForm(defaultValues: FormSchema) {
  return useForm({
    mode: 'all',
    resolver: zodResolver(formSchema),
    defaultValues,
  });
}
